/* eslint-disable */
import { FormRecordFieldView, FormRecordFieldViewFactory, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import { FormRecordStringFieldComponent } from '../../admin/form/form-record/fields/string/form-record-string-field.component';
/* eslint-enable */

export class FormRecordStringFieldViewFactory implements FormRecordFieldViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createView(): ComponentRef<FormRecordFieldView> {
    const cmp = this.cfr.resolveComponentFactory(FormRecordStringFieldComponent)
      .create(this.injector);
    return cmp;
  }

}
